module.exports = __webpack_public_path__ + "assets/img/btn-download-steam-5f59b255.png";